import React from "react";
import { Route, Redirect } from "react-router-dom";
import AuthManager from "../Common/AuthManager";

const PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      // AuthManager.isAuthenticated() ? (
      //   <Layout>
      //     <Component {...props} />
      //   </Layout>
      // ) : (
      //   <Redirect
      //     to={{ pathname: "/login", state: { from: props.location } }}
      //   />
      // )
      {
        if (
          AuthManager.isAuthenticated()
          // &&
          // AuthManager.isWorkSpaceStatusGood()
        ) {
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }
        // else if (
        //   AuthManager.isAuthenticated() &&
        //   !AuthManager.isWorkSpaceStatusGood()
        // ) {
        //   return (
        //     <Redirect
        //       to={{ pathname: "/noindustry", state: { from: props.location } }}
        //     />
        //   );
        // }
        else {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }
      }
    }
  />
);

export default PrivateRoute;
